import { IS_WEB } from 'constants/platform'
import React, { useEffect, useRef, useState } from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { Separator } from 'widgets/Separator'
import { Switch } from 'widgets/Switch'
import { Text } from 'widgets/Text'

import { useTheme } from 'contexts/ThemeContext'

const styles = StyleSheet.create({
  titleContainer: {
    width: '60%',
    justifyContent: 'center',
  },
})

type NotificationSettingsProps = {
  index: number
  name: string
  push: boolean
  email: boolean
  onPushChange: () => void
  onEmailChange: () => void
}

export const NotificationSettingsRow = ({
  index,
  name,
  push,
  email,
  onPushChange,
  onEmailChange,
}: NotificationSettingsProps) => {
  const theme = useTheme()
  const displayHeader = index === 0

  const [pushState, setPushState] = useState<boolean>(push)
  const onPushValueChanged = (newValue: boolean) => {
    setPushState(newValue)
    onPushChange()
  }

  const [emailState, setEmailState] = useState<boolean>(email)
  const onEmailValueChanged = (newValue: boolean) => {
    setEmailState(newValue)
    onEmailChange()
  }

  const computedTopMargin = useRef<number | undefined>(undefined)
  useEffect(() => {
    if (!computedTopMargin.current) {
      let newTopMargin = 0
      if (!IS_WEB && displayHeader) {
        newTopMargin = theme.spacing.lg - 2
      } else if (displayHeader) {
        newTopMargin = theme.spacing.md + 2
      } else {
        newTopMargin = -2
      }

      computedTopMargin.current = newTopMargin
    }
  })

  return (
    <>
      <Box
        testID={`NotificationSettingsRow-${name}`}
        flexDirection='row'
        align='center'
        justifyContent='space-between'
        margin={{ vertical: 'lg' }}
      >
        <Box flexDirection='column' style={styles.titleContainer}>
          <Box flexDirection='row' align='center'>
            <Box
              flex={1}
              flexDirection='row'
              margin={{
                right: 'xs',
                top: computedTopMargin.current,
              }}
            >
              <Text fontWeight='bold' fontSize='md'>
                {name}
              </Text>
            </Box>
          </Box>
        </Box>

        <Box flexDirection='column'>
          {displayHeader && (
            <Box margin={{ top: -theme.spacing.md, bottom: theme.spacing.md }}>
              <Text fontWeight='bold' fontSize='sm' align='center'>
                Push
              </Text>
            </Box>
          )}

          <Switch isEnabled={pushState} onValueChanged={onPushValueChanged} />
        </Box>

        <Box flexDirection='column'>
          {displayHeader && (
            <Box margin={{ top: -theme.spacing.md, bottom: theme.spacing.md }}>
              <Text fontWeight='bold' fontSize='sm' align='center'>
                Email
              </Text>
            </Box>
          )}

          <Switch isEnabled={emailState} onValueChanged={onEmailValueChanged} />
        </Box>
      </Box>
      <Separator />
    </>
  )
}
